import { Routes } from '@angular/router';
import { PortInConfigService, portInRoutes } from '@rogers/self-serve-wireless/port-in';
import { ApiEndpointService } from '@rci/self-serve-shared';
import { getWirelessDeeplinkGuard } from '@rci/self-serve-fido/guard/routing.guards';
import { GroupIdOrSubscriberDeeplinkGuard } from '@rci/self-serve-fido/guard/group-id-or-subscriber-deeplink.guard';
import { provideAnalyticsConfiguration, provideSelfServeAnalyticsService } from '@rci/self-serve-fido/core/analytics';
import { portInConfiguration } from './analytics/port-in-analytics-configuration.service';
import { PortInAppConfigService } from './port-in-app.config.service';
import { PortInBreadcrumbsResolver } from './port-in-breadcrumbs.resolver';

export const portInAppRoutes: Routes = [
  {
    path: 'transfer-phone-number',
    children: portInRoutes,
    canActivate: [...getWirelessDeeplinkGuard('transfer-phone-number'), GroupIdOrSubscriberDeeplinkGuard],
    resolve: { breadcrumbs: PortInBreadcrumbsResolver },
    providers: [
      provideAnalyticsConfiguration(portInConfiguration),
      provideSelfServeAnalyticsService(),
      {
        provide: PortInConfigService,
        useClass: PortInAppConfigService,
        deps: [ApiEndpointService],
      },
    ],
  },
];
